// @ts-nocheck

// Orientation modes
export const ViewportOrientations = Object.freeze({
  NONE: 0,
  LANDSCAPE: 1,
  PORTRAIT: 2,
});
